<template>
	<BasicDialog width="w-100 w-sm-100 w-md-75 w-lg-50 w-xl-50" :scrollable="true">
		<ContactUsDialogBanner></ContactUsDialogBanner>
		<div class="text-h5 font-weight-bold">How can we help?</div>
		<div class="text-body-2 my-2">Submit a ticket and we will contact you soon</div>
		<ContactUsForm />
	</BasicDialog>
</template>



<script setup>

import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import ContactUsDialogBanner from "@/components/Faq/ContactUs/Contact-Us-Banner.vue";
import ContactUsForm from "@/components/Faq/ContactUs/Contact-Us-Form.vue";

</script>